<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">SELECT CUSTOM ACTION</h4>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <div class="dropdown">
                  <button 
                    class="btn btn-outline-secondary dropdown-toggle w-100" 
                    type="button" 
                    id="customActionsDropdown" 
                    data-bs-toggle="dropdown" 
                    aria-expanded="false"
                    style="text-align: left; padding: 15px;">
                    {{ customAction ? customAction.actionName : 'Select a custom action...' }}
                  </button>
                  <div class="dropdown-menu w-100" aria-labelledby="customActionsDropdown">
                    <div v-for="action in customActions" :key="action.uuid" class="dropdown-item custom-action-item" @click="selectAction(action)">
                      <div class="d-flex flex-column">
                        <h6 class="mb-1">{{ action.actionName }}</h6>
                        <small class="text-muted">{{ action.description }}</small>
                      </div>
                    </div>
                    <div v-if="customActions.length === 0" class="dropdown-item text-center text-muted">
                      No custom actions available
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import menuApi from "@/shared/menuApi";
import { useToast } from "vue-toastification";

export default {
  props: {
    customAction: {
      type: Object,
      default: {}
    } 

  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      customActions: [],
    };
  },
  methods: {
    async getCustomActions() {
      try {
        const response = await menuApi.doGet("/api/custom-actions");
        if (response.status === "00") {
          this.customActions = response.data;
        } else {
          this.toast.error(response.message);
        }
      } catch (error) {
        this.toast.error(error.message || "Failed to fetch custom actions");
      }
    },
    selectAction(action) {
      this.customAction.uuid = action.uuid;
      this.customAction.description= action.description;
      this.customAction.actionName = action.actionName;
    }
  },
  mounted() {
    this.getCustomActions().then(() => {
       if (this.customAction && this.customAction.uuid) {
        const selectedAction = this.customActions.find(action => action.uuid === this.customAction.uuid);
        if (selectedAction) {
           console.log("The selected action is>>" + JSON.stringify(selectedAction));
           this.selectAction(selectedAction);
        }
      }
    });
  }
};
</script>

<style scoped>
.custom-action-item {
  padding: 10px 15px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.custom-action-item:hover {
  background-color: rgba(74, 158, 255, 0.1);
}

.custom-action-item h6 {
  margin: 0;
  color: #4a9eff;
}

.custom-action-item small {
  font-size: 0.85rem;
}

.dropdown-menu {
  max-height: 300px;
  overflow-y: auto;
  background-color: #23243a;
  border: 1px solid #3444eb;
  padding: 0;
}

.dropdown-menu .dropdown-item {
  color: #fff;
  border-bottom: 1px solid rgba(52, 68, 235, 0.2);
}

.dropdown-menu .dropdown-item:last-child {
  border-bottom: none;
}

.dropdown-menu .dropdown-item:hover {
  background-color: rgba(52, 68, 235, 0.1);
}

.btn-outline-secondary {
  background-color: #23243a;
  border-color: #3444eb;
  color: #fff;
}

.btn-outline-secondary:hover,
.btn-outline-secondary:focus {
  background-color: #2b2e4c;
  border-color: #3444eb;
  color: #fff;
}
</style>